<admin-menu *ngIf="userRole === 'ROLE_ADMIN'"></admin-menu>
<watcher-menu *ngIf="userRole === 'ROLE_WATCHER'"></watcher-menu>
<agent-menu *ngIf="userRole === 'ROLE_AGENT'"></agent-menu>
<app-accountant-menu *ngIf="userRole === 'ROLE_ACCOUNTANT'"></app-accountant-menu>
<supervisor-menu *ngIf="userRole === 'ROLE_SUPERVISOR'"></supervisor-menu>
<user-menu *ngIf="userRole === 'ROLE_ENTERPRISE_USER'"></user-menu>
